module.exports = {
    "smMinWidth": "576px",
    "mdMinWidth": "768px",
    "lgMinWidth": "992px",
    "xlMinWidth": "1200px",
    "xxlMinWidth": "1600px"
}
